import { ApplicationNames } from '@ddt-web/domain';

import { AcPortfolioLibraryRcs, CmaRcs, IqRcs, IretireRcs, MexRcs, NileRcs, PaRcs, PiRcs, SharedRcs, StRcs } from '../enums/pas-rcs.enum';
import { PasDataServiceApiUtil } from '../utils/pas-data-service-api.util';

export class PasDataServiceApiConstants {
	public static readonly CONFIG_VENDOR_VIEW_ID = 'modelPortfolio@blackrock';

	public static readonly AS_OF_DATE_TYPES = {
		LATEST: 'LATEST',
		APPROVED: 'APPROVED',
		PRE_APPROVED: 'PREV_APPROVED'
	};

	public static readonly BENCHMARK_TYPES = {
		DEFAULT: 'benchmark'
	};

	public static readonly SECURITY_DETAILS = 'security-details';
	public static readonly SECURITY_DETAILS_COMPARE = 'security-details-compare';
	public static readonly SECURITY_DETAILS_TAX = 'security-details-tax';
	public static readonly SECURITY_DETAILS_BLK_IDEAS = 'security-details-blk-ideas';
	public static readonly MODEL_DETAILS = 'model-details';
	public static readonly MODEL_FAMILIES = 'model-families';
	public static readonly PERFORMANCE = 'performance';
	public static readonly ESG = 'esg';

	public static readonly PC_PORTFOLIO_ANALYSIS_RCS = {
		details: PasDataServiceApiUtil.createPcRcsPath(NileRcs.DETAILS),
		performance: PasDataServiceApiUtil.createPcRcsPath(NileRcs.PERFORMANCE),
		risk: PasDataServiceApiUtil.createPcRcsPath(NileRcs.RISK),
		'correlation-matrix': PasDataServiceApiUtil.createPcRcsPath(NileRcs.CORRELATION_MATRIX),
		'security-details': PasDataServiceApiUtil.createPcRcsPath(SharedRcs.SECURITY_DETAILS)
	};

	public static readonly SCENARIO_TESTER_RCS = {
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		scenarioTesterDetails: PasDataServiceApiUtil.createAcRcsPath(StRcs.DETAILS),
		performance: PasDataServiceApiUtil.createAcRcsPath(StRcs.PERFORMANCE),
		risk: PasDataServiceApiUtil.createAcRcsPath(StRcs.RISK),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly MY_PORTFOLIOS_RCS = {
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly CMA_PORTFOLIO_ANALYSIS_RCS = {
		wealthProjections: PasDataServiceApiUtil.createAcRcsPath(SharedRcs.WEALTH_PROJECTIONS),
		details: PasDataServiceApiUtil.createAcRcsPath(CmaRcs.DETAILS),
		risk: PasDataServiceApiUtil.createAcRcsPath(CmaRcs.RISK),
		performance: PasDataServiceApiUtil.createAcRcsPath(CmaRcs.PERFORMANCE),
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly PORTFOLIO_ANALYSER_RCS = {
		esg: PasDataServiceApiUtil.createAcRcsPath(PaRcs.ESG),
		risk: PasDataServiceApiUtil.createAcRcsPath(PaRcs.RISK),
		performance: PasDataServiceApiUtil.createAcRcsPath(PaRcs.PERFORMANCE),
		details: PasDataServiceApiUtil.createAcRcsPath(PaRcs.DETAILS),
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'security-details-tax': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS),
		'security-details-blk-ideas': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES),
		wealthProjections: PasDataServiceApiUtil.createAcRcsPath(SharedRcs.WEALTH_PROJECTIONS)
	};

	public static readonly IRETIRE_RCS = {
		risk: PasDataServiceApiUtil.createAcRcsPath(IretireRcs.RISK),
		'au-risk': PasDataServiceApiUtil.createAuRcsPath(IretireRcs.RISK),
		'model-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_DETAILS),
		'au-model-details': PasDataServiceApiUtil.createAuRcsPath(SharedRcs.MODEL_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES),
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'au-security-details': PasDataServiceApiUtil.createAuRcsPath(SharedRcs.SECURITY_DETAILS)
	};

	public static readonly TAX_ESTIMATOR_RCS = {
		'security-details-tax': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS),
		'security-details-blk-ideas': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly INVESTMENT_QUALITY_RCS = {
		details: PasDataServiceApiUtil.createAcRcsPath(IqRcs.DETAILS),
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'security-details-compare': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS_COMPARE),
		'fundAnalytics': PasDataServiceApiUtil.createAcRcsPath(IqRcs.FUND_ANALYTICS),
		'security-details-tax': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly PROFESSIONAL_INVESTORS_RCS = {
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		details: PasDataServiceApiUtil.createAcRcsPath(PiRcs.DETAILS),
		performance: PasDataServiceApiUtil.createAcRcsPath(PiRcs.PERFORMANCE),
		risk: PasDataServiceApiUtil.createAcRcsPath(PiRcs.RISK),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly AC_PORTFOLIO_LIBRARY_RCS = {
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'security-details-tax': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS),
		details: PasDataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.DETAILS),
		performance: PasDataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.PERFORMANCE),
		performanceExBenchmark: PasDataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.PERFORMANCE_EXCLUDE_BENCHMARK),
		risk: PasDataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.RISK),
		rules: PasDataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.RULES),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly MODELS_EXPERIENCE_RCS = {
		'model-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_DETAILS),
		'au-model-details': PasDataServiceApiUtil.createAuRcsPath(SharedRcs.MODEL_DETAILS),
		performance: PasDataServiceApiUtil.createAcRcsPath(MexRcs.PERFORMANCE),
		'au-performance': PasDataServiceApiUtil.createAuRcsPath(MexRcs.PERFORMANCE),
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'au-security-details': PasDataServiceApiUtil.createAuRcsPath(SharedRcs.SECURITY_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES),
		'au-model-families': PasDataServiceApiUtil.createAuRcsPath(SharedRcs.MODEL_FAMILIES),
		'esg': PasDataServiceApiUtil.createAcRcsPath(MexRcs.ESG),
		'au-esg': PasDataServiceApiUtil.createAuRcsPath(MexRcs.ESG)
	};

	public static readonly DASHBOARD_RCS = {
		'security-details': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.SECURITY_DETAILS),
		'model-families': PasDataServiceApiUtil.createAcRcsPath(SharedRcs.MODEL_FAMILIES)
	};

	public static readonly PAS_RCS = {
		[ApplicationNames.PORTFOLIO_CENTRE]: { ...PasDataServiceApiConstants.PC_PORTFOLIO_ANALYSIS_RCS },
		[ApplicationNames.PORTFOLIO_CENTRE_360]: { ...PasDataServiceApiConstants.PC_PORTFOLIO_ANALYSIS_RCS },
		[ApplicationNames.CMA_ESTIMATOR]: { ...PasDataServiceApiConstants.CMA_PORTFOLIO_ANALYSIS_RCS },
		[ApplicationNames.PORTFOLIO_ANALYSER]: { ...PasDataServiceApiConstants.PORTFOLIO_ANALYSER_RCS },
		[ApplicationNames.INVESTMENT_QUALITY]: { ...PasDataServiceApiConstants.INVESTMENT_QUALITY_RCS },
		[ApplicationNames.PROFESSIONAL_INVESTORS]: { ...PasDataServiceApiConstants.PROFESSIONAL_INVESTORS_RCS },
		[ApplicationNames.AC_PORTFOLIO_LIBRARY]: { ...PasDataServiceApiConstants.AC_PORTFOLIO_LIBRARY_RCS },
		[ApplicationNames.TAX_ESTIMATOR]: { ...PasDataServiceApiConstants.TAX_ESTIMATOR_RCS },
		[ApplicationNames.SCENARIO_TESTER]: { ...PasDataServiceApiConstants.SCENARIO_TESTER_RCS },
		[ApplicationNames.MY_SAVED_PORTFOLIOS]: { ...PasDataServiceApiConstants.MY_PORTFOLIOS_RCS },
		[ApplicationNames.MODELS_EXPERIENCE]: { ...PasDataServiceApiConstants.MODELS_EXPERIENCE_RCS },
		[ApplicationNames.IRETIRE_ACCUM]: { ...PasDataServiceApiConstants.IRETIRE_RCS },
		[ApplicationNames.IRETIRE_DECUM]: { ...PasDataServiceApiConstants.IRETIRE_RCS },
		[ApplicationNames.DASHBOARD]: { ...PasDataServiceApiConstants.DASHBOARD_RCS }
	};

	public static readonly PORTFOLIO_ANALYSIS_RCS = {
		details: 'bfa:portfolio-analyser',
		risk: 'bfa:portfolio-analyser-risk',
		performance: 'bfa:portfolio-analyser-performance', // Use only this for performance
		netPerformance: 'bfa:portfolio-analyser-net-performance', // Use only this for netPerformance
		netCustomPerformance: 'bfa:portfolio-analyser-net-performance', // Use only this for net performance when user provides custom advisory fee
		performanceCommonPeriods: 'bfa:portfolio-analyser-performance', // This is for performance when comparing portfolios and we need to use common periods
		netPerformanceCommonPeriods: 'bfa:portfolio-analyser-net-performance', // This is for net performance when comparing portfolios and we need to use common periods
		netCustomPerformanceCommonPeriods: 'bfa:portfolio-analyser-net-performance', // This is for net performance when user provides custom advisory fee and comparing portfolios and we need to use common periods
		scenarioTesterDetails: 'bfa:portfolio-analyser',
		portfolioImpact: 'bfa:portfolio-analyser-impact',
		mbDetails: 'bfa:mval:portfolio-analyser,bfa:products-us'
	};

	public static readonly PORTFOLIO_ANALYSIS_SLEEVE_RCS_SUFFIX = '-sleeve';
	public static readonly PORTFOLIO_ANALYSIS_SIMPLE_RCS_SUFFIX = '-simple';

	public static readonly STORES = {
		ASSOCIATED_PORTFOLIOS: 'associatedPortfolios',
		DETAILS: 'details',
		FUNDS_TO_EXPLORE: 'fundsToExplore',
		PERFORMANCE: 'performance',
		NET_PERFORMANCE: 'netPerformance',
		NET_CUSTOM_PERFORMANCE: 'netCustomPerformance',
		PERFORMANCE_COMMON_PERIODS: 'performanceCommonPeriods',
		NET_PERFORMANCE_COMMON_PERIODS: 'netPerformanceCommonPeriods',
		NET_CUSTOM_PERFORMANCE_COMMON_PERIODS: 'netCustomPerformanceCommonPeriods',
		RISK: 'risk',
		PORTFOLIO_IMPACT: 'portfolioImpact',
		MB_DETAILS: 'mbDetails'
	};

	public static readonly STORES_PREFIXES = {
		APPROVED_PREFIX: 'approved-',
		LATEST_PREFIX: 'latest-',
		REBALANCE_PREFIX: 'rebalance-'
	};

	public static readonly FTE_TRANSITION_ID = 'fte-transition';

	public static readonly IDENTIFIER_TYPES = {
		SECURITY: 'SECURITY_ID'
	};

	public static readonly TAX_ESTIMATES_MAPPING = {
		'Active': null,
		'Pending': 'CAP_GAINS_STATUS_PENDING',
		'Not Distributing': 'CAP_GAINS_STATUS_NOT_EXPECTED',
		'Distributed': 'CAP_GAINS_STATUS_PASSED'
	};

	public static readonly LOCALE_CURRENCY_MAPPING = {
		us: 'USD',
		au: 'AUD'
	};
}
